import { createReducer } from "@reduxjs/toolkit"

export default createReducer([], {
  ENQUEUE_SNACKBAR: (state, action) => [
    ...state,
    {
      key: action.key,
      ...action.payload
    }
  ],
  CLOSE_SNACKBAR: (state, action) =>
    state.map((notification) =>
      action.payload.dismissAll || notification.key === action.payload.key
        ? { ...notification, dismissed: true }
        : { ...notification }
    ),
  REMOVE_SNACKBAR: (state, action) =>
    state.filter((notification) => notification.key !== action.payload.key)
})
